import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { XFlowNodeCommands } from '../constant';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
export var NsCenterNode;
(function (NsCenterNode) {
    NsCenterNode.command = XFlowNodeCommands.CENTER_NODE;
    NsCenterNode.hookKey = 'centerNode';
})(NsCenterNode || (NsCenterNode = {}));
let CenterNodeCommand = class CenterNodeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.centerNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { nodeConfig } = handlerArgs;
                const x6Node = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.id);
                x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.centerCell(x6Node);
                return { x6Node };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], CenterNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CenterNodeCommand.prototype, "init", null);
CenterNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsCenterNode.command.id },
    })
    /** 节点在画布居中命令 */
], CenterNodeCommand);
export { CenterNodeCommand };
//# sourceMappingURL=node-center.js.map